import React from "react";
import {
  Box,
  Container,
  Grid,
  Stack,
  IconButton,
} from "@mui/material";

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import logo from "../../assets/logo/logoblanco.png";

export default function Footer() {

  const redesSociales = [
    {
      nombre: "Facebook",
      icon: <FacebookIcon />,
      url: "https://www.facebook.com/profile.php?id=100064115081323",
      hover: "#2563eb",
    },
    {
      nombre: "Instagram",
      icon: <InstagramIcon />,
      url: "https://www.instagram.com/colegioantilenrengo/channel/",
      hover: "#e1306c",
    },
    {
      nombre: "YouTube",
      icon: <YouTubeIcon />,
      url: "https://www.youtube.com/channel/UC-hJsXRYyBvLzPjnCfov2GQ",
      hover: "#ff0000",
    },
    {
      nombre: "WhatsApp",
      icon: <WhatsAppIcon />,
      url: "https://wa.me/56932385589",
      hover: "#25D366",
    },
  ];

  return (

    <Box
      component="footer"
      sx={{
        background: "#8f1515",
        color: "#fff",
        pt: 6,
        pb: 3,
      }}
    >

      <Container maxWidth="xl">

        <Grid container spacing={5}>

          {/* REDES SOCIALES */}

          <Grid size={{ xs: 12, sm: 6 }}>

            <Stack
              direction="row"
              spacing={1}
            >

              {redesSociales.map((red) => (

                <IconButton
                  key={red.nombre}
                  component="a"
                  href={red.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={red.nombre}
                  sx={{
                    color: "#fff",

                    background:
                      "rgba(255,255,255,0.1)",

                    transition:
                      "all .3s ease",

                    "&:hover": {
                      background: red.hover,
                      transform:
                        "translateY(-3px)",
                    },
                  }}
                >
                  {red.icon}
                </IconButton>

              ))}

            </Stack>

          </Grid>


          {/* LOGO */}

          <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: {
                xs: "flex-start",
                sm: "flex-end",
              },
            }}
          >

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >

              <img
                src={logo}
                alt="Colegio Antilen"
                style={{
                  width: 160,
                }}
              />

            </Box>

          </Grid>

        </Grid>

      </Container>

    </Box>

  );
}